module.exports = __webpack_public_path__ + "img/hero-5.d61cc537.png";